(async () => {
    const { Core } = await importModule('Core');
    const expandedFilters = new Set();

    customElements.define('collection-filter', class extends Core {
        render() {
            this.addEventListener('change', this._changeHandler.bind(this));
            this.addEventListener('click', this._clickHandler.bind(this));

            if(expandedFilters.has(this.id)) {
                this._setExpanded(true);
            }
        }
        _changeHandler(e) {
            this.publish('filter:change');
        }
        _clickHandler(e) {
            const $toggle = e.target.closest('[data-filter-toggle]');
            if(!$toggle || !this.contains($toggle)) return;

            const expanded = $toggle.getAttribute('aria-expanded') === 'true';
            this._setExpanded(!expanded);

            if(expanded) {
                expandedFilters.delete(this.id);
            } else {
                expandedFilters.add(this.id);
            }
        }
        _setExpanded(expanded) {
            const $toggle = this.querySelector('[data-filter-toggle]');
            if(!$toggle) return;

            this.querySelectorAll('[data-filter-overflow-item]').forEach($item => {
                $item.hidden = !expanded;
            });
            $toggle.setAttribute('aria-expanded', expanded.toString());
            $toggle.querySelector('[data-filter-show-more]').hidden = expanded;
            $toggle.querySelector('[data-filter-show-less]').hidden = !expanded;
        }
    })
})();
